import Lottie from "lottie-react";
import React from "react";
import { twMerge } from "tailwind-merge";

export interface LottieAnimationProps {
  /**
   * The Lottie animation JSON data
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  animationData: any;
  /**
   * Custom className for styling
   */
  className?: string;
  /**
   * Width of the animation container
   */
  width?: string | number;
  /**
   * Height of the animation container
   */
  height?: string | number;
  /**
   * Whether the animation should loop
   */
  loop?: boolean;
  /**
   * Whether the animation should autoplay
   */
  autoplay?: boolean;

  /**
   * Callback fired when animation is complete
   */
  onComplete?: () => void;
  /**
   * Callback fired when animation is loaded
   */
  onLoad?: () => void;
  /**
   * Additional styles for the container
   */
  style?: React.CSSProperties;
}

export const LottieAnimation: React.FC<LottieAnimationProps> = ({
  animationData,
  className,
  width = "100%",
  height = "100%",
  loop = true,
  autoplay = true,
  onComplete,
  onLoad,
  style,
}) => {
  return (
    <div
      className={twMerge("flex items-center justify-center", className)}
      style={{
        width,
        height,
        ...style,
      }}
    >
      <Lottie
        animationData={animationData}
        loop={loop}
        autoplay={autoplay}
        onComplete={onComplete}
        onLoad={onLoad}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default LottieAnimation;
